// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__MG-tR","selected":"Chip_selected__2DcSy"};